/* eslint-disable max-lines-per-function */
import React, { useState } from 'react';
import styled from 'styled-components';
import compose from 'lodash/fp/compose';
import { getIn } from 'seamless-immutable';
import { withConfig } from '@catalogo/core-connect/config';
import { withCookies } from '@catalogo/core-connect/cookies';
import { Observer } from '@catalogo/theme-observer';
import BuyButton from '@catalogo/ui-americanas-mobile-buy-button';
import BuyAme from '@catalogo/ui-americanas-mobile-buy-ame';
import WeddingList from '@catalogo/ui-americanas-mobile-wedding-list';
import { TheftProtection } from '@catalogo/ui-americanas-mobile-theft-protection';
import FloatAreaButton from './float-area-button';
import SmartBanner from './smart-banner';

export const BuyArea = ({
  offer,
  page,
  product,
  currentSku,
  cookies,
  config,
  experiment,
  discountProgressiveExperiment,
  selectQuantityWasUsed,
  breadcrumb,
  parsedQs,
  location,
  servicePDPinfoForWarranty,
  history,
}) => {
  const [showFloatArea, setShowFloatArea] = useState(false);
  const isO2O = getIn(offer, ['seller', 'id']) === '33014556000196';
  const isBoleto = getIn(offer, ['bestPaymentOption', 'type']) === 'BOLETO';
  const isBuyAmeEnabled = getIn(page, ['components', 'page-config', 'features'], '').split(', ').includes('BUY_AME');
  const isGiftVoucher = getIn(product, ['isGiftVoucher'], false);
  const enableAme = !isBoleto && !isO2O && isBuyAmeEnabled && !isGiftVoucher;
  const isSmartPhone = getIn(product, ['categories'], []).includes('CELLPHONE');
  const hasSmartBannerPublication = !!getIn(page, ['components', 'smartBanner'], false);
  const observerButton = (isVisible, position) => {
    if (!isVisible && position === 'above') {
      return setShowFloatArea(true);
    }

    return setShowFloatArea(false);
  };

  const renderSecondaryButton = enableAme => {
    const currentSellerId = getIn(currentSku, ['offers', 'result', '0', 'seller', 'id']);
    const isB2WSeller = currentSellerId === getIn(config, ['sellerId'], '');
    const isWeddingList = !!getIn(cookies, ['listId'], '') && isB2WSeller;

    if (isWeddingList) {
      return <WeddingList isDesk currentSku={currentSku} />;
    }

    return enableAme && <BuyAme />;
  };

  return (
    <ButtonsWrapper>
      <TheftProtection />
      <Observer rootMargin="" onVisible={({ isVisible, position }) => observerButton(isVisible, position)}>
        <div>
          <BuyButton
            isO2O={isO2O}
            product={product}
            currentSku={currentSku}
            categoryUrl={breadcrumb?.[0]?.url}
            productId={getIn(product, ['id'])}
            isPreSale={getIn(product, ['isPreSale'])}
            experiment={experiment}
            discountProgressiveExperiment={discountProgressiveExperiment}
            selectQuantityWasUsed={selectQuantityWasUsed}
            servicePDPinfoForWarranty={servicePDPinfoForWarranty}
            history={history}
          />
        </div>
      </Observer>
      {renderSecondaryButton(enableAme)}
      {showFloatArea && (
        <FloatAreaButton
          currentSku={currentSku}
          page={page}
          product={product}
          productId={getIn(product, ['id'])}
          isPreSale={getIn(product, ['isPreSale'])}
          isO2O={isO2O}
          enableAme={enableAme}
          experiment={experiment}
          discountProgressiveExperiment={discountProgressiveExperiment}
          servicePDPinfoForWarranty={servicePDPinfoForWarranty}
          history={history}
        />
      )}
      {!showFloatArea && isSmartPhone && hasSmartBannerPublication && (
        <SmartBanner publication={getIn(page, ['components', 'smartBanner'])} />
      )}
    </ButtonsWrapper>
  );
};

const ButtonsWrapper = styled.div`
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
`;

export default compose(withCookies, withConfig)(BuyArea);
